<template>
  <div>
    <div class="main-ttl container-xl">
      <h2>
        <span>{{ headingTitle }}</span>
        <small>{{ headingDesc }}</small>
      </h2>
    </div>

    <main class="container-xl">
      <div class="primary-area setting-area bg-none-sm">
        <HeaderSetting />

        <div class="outside-ttl-sm">
          <div class="section-ttl list-btn-area">
            <h3>請求書・領収書</h3>
          </div>

          <!-- 通知アドレス登録なし --------------------------- -->
          <div v-if="items === null"></div>
          <div
            v-else-if="items.length === 0"
            class="mb-5"
            :class="{
              'animate__animated': true,
              'animate__fadeIn': items.length === 0,
            }"
          >
            <ul class="list-unstyled setting-list pdf-list no-item">
              <li class="row">
                <div>まだ請求書・領収書は<span>発行されていません。</span></div>
              </li>
            </ul>
          </div>

          <template v-else>
          <!-- 領収書・請求書一覧--------------------------- -->
          <ul class="row list-unstyled small list-head pdf-head">
            <li class="col-sm-2">日付</li>
            <li class="col-md-4">種類</li>
            <li class="col-2">お支払い金額</li>
            <li class="col-1 column-ico">PDF</li>
          </ul>

          <ul v-if="items.length" class="list-unstyled setting-list pdf-list pb-5"
            :class="{
              'animate__animated': true,
              'animate__fadeIn': items.length > 0,
            }"
          >
            <li class="row" :key="index" v-for="(paymentHistory, index) in items">
              <div class="col-sm-2">{{ paymentHistory.getIssueDate() }}</div>
              <div class="col-md-4">{{ paymentHistory.getIssueTypeText() }}
                （{{ paymentHistory.getBillingDateText("YYYY年MM月") }}請求分）</div>
              <div class="col-2">
                {{ paymentHistory.billingAmountIncludingTax.toLocaleString() }}円
              </div>
              <div class="col-1 column-ico">
              <a href="#" @click.prevent="downloadPdf(paymentHistory)">
                <Icon :src="icons.DownloadIcon" alt="ダウンロードアイコン" />
              </a></div>
            </li>
          </ul>
          </template>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
// import NotificationRecipient from "models/notification-recipient";

import { Icon } from "components";
import { HeaderSetting } from "containers";
import { CrossIcon, SendIcon, DownloadIcon } from "icons";
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

import { PaymentHistory } from "models/billing";

const BillingsRepository = RepositoryFactory.get("billings");

export default {
  name: "BillingsList",
  components: {
    HeaderSetting,
    Icon,
  },
  data() {
    return {
      headingTitle: "サービスアカウント設定",
      headingDesc: "サービスアカウントの登録情報です。",
      icons: {
        CrossIcon,
        SendIcon,
        DownloadIcon,
      },
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
    }),
  },
  async created() {
    /* 初期化処理 */
    try {
      // 監視対象一覧の取得
      this.items = [];
      const paymentHistory = await BillingsRepository.getPaymentHistory(
        this.currentServiceAccount.serviceAccountId,
      );
      paymentHistory.forEach((item) => {
        this.items.push(PaymentHistory.createInstance(item));
      });

      // 画面機能を有効化
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    } catch (err) {
      console.log(err);
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotificaton: "notification/resetState",
      setNotification: "notification/setNotification",
      setErrorNotification: "notification/setErrorNotification",
    }),
    downloadPdf(paymentHistory) {
      if (paymentHistory.issueType === "invoice") {
        this.$router.push({
          name: "BillingsInvoice",
          params: {
            id: paymentHistory.billingId,
          },
        });
      } else if (paymentHistory.issueType === "receipt") {
        this.$router.push({
          name: "BillingsReceipt",
          params: {
            id: paymentHistory.billingId,
          },
        });
      }
    },
  },
};
</script>
